import BezierEasing from "bezier-easing";
const getProgress = ({ elapsed, total }) => Math.min(elapsed / total, 1);
const getEasing = (easingCurve) => BezierEasing(...easingCurve);
const getTiming = (duration) => ({
  start: window.performance.now(),
  total: duration,
  elapsed: 0
});
const animateCSS = (element, animationParams) => {
  const opts = {
    animateFrom: 0,
    animateTo: 0,
    duration: 300,
    easing: [0.32, 0.94, 0.6, 1],
    units: "px",
    ...animationParams
  };
  const time = getTiming(opts.duration);
  const easing = getEasing(opts.easing);
  const distanceToMove = opts.animateTo - opts.animateFrom;
  return new Promise((resolve) => {
    const tick = (now) => {
      const elapsed = now - time.start >= 0 ? now - time.start : 0;
      const newTime = { ...time, elapsed };
      const progress = easing(getProgress(newTime));
      const step = progress * distanceToMove;
      element.style.left = step + opts.animateFrom + opts.units;
      if (progress < 1) return window.requestAnimationFrame(tick);
      return resolve(element);
    };
    window.requestAnimationFrame(tick);
  });
};
export {
  animateCSS,
  getEasing,
  getProgress,
  getTiming
};
//# sourceMappingURL=animate.mjs.map
